import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  NavigationGuard,
} from 'vue-router';
import authRouter from '@/oauth2-mobile-wx/routes/index';
import rely from '../oauth2-mobile-wx/oauth2rely';
import store from '@/store';
const Login: NavigationGuard = (to, from, next) => {
  rely.checkLogin(to, next);
  next();
};

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    beforeEnter: Login,
    component: () => import('@/components/Layout.vue'),
    redirect: {
      name: 'taskList',
    },
    children: [
      {
        path: '/resource-map',
        name: 'resourceMap',
        component: () => import('@/views/resourceMap/index.vue'),
        meta: {
          title: '资源地图',
        },
      },
      {
        path: '/task-list',
        name: 'taskList',
        component: () => import('@/views/task/taskList.vue'),
        meta: {
          title: '任务列表',
          keepAlive: true,
        },
      },
      {
        path: '/task-audit-list',
        name: 'taskAuditList',
        component: () => import('@/views/task/taskAuditList.vue'),
        meta: {
          title: '任务审核',
          keepAlive: true,
        },
      },
      {
        path: '/task-edit',
        name: 'taskEdit',
        component: () => import('@/views/task/taskEdit.vue'),
        meta: {
          title: '任务详情',
          keepAlive: true,
        },
      },
      {
        path: '/file-list',
        name: 'fileList',
        component: () => import('@/views/task/components/fileList.vue'),
        meta: {
          title: '文件列表',
          keepAlive: true,
        },
      },
      {
        path: '/workTimeList',
        name: 'workTimeList',
        component: () => import('@/views/task/components/workTimeList.vue'),
        meta: {
          title: '工时记录',
          keepAlive: false,
        },
      },
      {
        path: '/project-warning',
        name: 'projectWarning',
        component: () => import('@/views/projectWarning/index.vue'),
        meta: {
          title: '项目预警提醒',
        },
      },

      {
        path: '/task-message/:TaskGUID',
        // beforeEnter: Login,
        name: 'taskMessage',
        component: import('@/views/TaskMessage.vue'),
        meta: {
          title: '任务消息提醒',
        },
      },
      {
        path: '/task-message/notfound',
        name: 'notfound',
        // beforeEnter: Login,
        component: import('@/views/Notfound.vue'),
        meta: {
          title: '任务消息提醒',
        },
      },
      {
        path: '/timeAudit',
        name: 'timeAudit',
        component: () => import('@/views/timeAudit/index.vue'),
        meta: {
          title: '工时审核',
        },
      },
      {
        path: '/timeAuditList',
        name: 'timeAuditList',
        component: () => import('@/views/timeAudit/list.vue'),
        meta: {
          title: '任务审核列表',
        },
      },
      {
        path: '/timeAuditDetails',
        name: 'timeAuditDetails',
        component: () => import('@/views/timeAudit/details.vue'),
        meta: {
          title: '任务详情',
        },
      },
    ],
  },

  authRouter(),
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0,
        left: 0,
        top: 0,
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title as any;
  }
  // const store = useStore();

  if (to.name === 'taskEdit' && from.name === 'fileList') {
    store.commit('taskList/setFromFileList', true);
  } else {
    store.commit('taskList/setFromFileList', false);
  }

  next();
});

export default router;
